<template>
    <div class="container">
        <div v-if="direcciones.length" class="row">
            <div class="col-lg-4 col-sm-6 col-12 block-squad">
                <b-button v-b-modal.modal-new-direccion class="btn-new-address" @focus.prevent="$event.target.blur()">
                    <div class="icon_block">
                        <div class="contain">
                            <div class="icon">
                                <i class="fas fa-plus-circle"></i>
                            </div>
                        </div>
                    </div>
                    Añadir dirección
                </b-button>
            </div>

            <div v-for="(direccion, index) in direcciones" class="col-lg-4 col-sm-6 col-12 block-squad">
                <div class="block_content">
                    <div>
<!--                        <div class="small_title">-->
<!--                            {{direccion.nombre_direccion?direccion.nombre_direccion:'&#45;&#45;'}}-->
<!--                        </div>-->
                        <div class="title">
                            {{direccion.nombre||direccion.apellidos?direccion.nombre+' '+direccion.apellidos:'--'}}
                        </div>
                        <div class="content_body">
                            <div class="body_info">
                                <div>{{direccion.direccion?direccion.direccion:'--'}}</div>
                                <div>{{direccion.cod_postal?direccion.cod_postal:'--'}}</div>
                                <div>{{direccion.poblacion_nombre?direccion.poblacion_nombre:'--'}}</div>
                                <div>{{direccion.provincia.nombre?direccion.provincia.nombre:'--'}}</div>
                                <div>{{direccion.pais.nombre?direccion.pais.nombre:'--'}}</div>
                            </div>
                        </div>
                        <div class="predeterminada">
                            <div class="item" v-if="direccion.requiere_re">
                                <div>
                                    <svg class="dx-icon" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                        <path d="M7.5 13.1L2.4 9.3l1.2-1.6 3.5 2.6 4.7-6.5 1.6 1.1-5.9 8.2z"></path>
                                    </svg>
                                    <span class="text">Recargo de equivalencia</span>
                                </div>
                            </div>
                            <div class="item" v-if="direccion.pred_facturacion">
                                <div>
                                    <svg class="dx-icon" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                        <path d="M7.5 13.1L2.4 9.3l1.2-1.6 3.5 2.6 4.7-6.5 1.6 1.1-5.9 8.2z"></path>
                                    </svg>
                                    <span class="text">Dirección de facturación</span>
                                </div>
                            </div>
                            <div class="item" v-if="direccion.pred_envio">
                                <div>
                                    <svg class="dx-icon" height="1em" width="1em" focusable="false" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                        <path d="M7.5 13.1L2.4 9.3l1.2-1.6 3.5 2.6 4.7-6.5 1.6 1.1-5.9 8.2z"></path>
                                    </svg>
                                    <span class="text">
                                        Dirección de envío
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="footer">
                            <div class="delete">
                                <button @click="removeAddress(direccion.id)">
                                    <span>
                                        <i class="fas fa-trash-alt"></i>
                                    </span>
                                </button>
                            </div>
                            <div class="contenido">
                                <div class="bp-form-group">
                                    <b-button @click="editAddress(index)" @focus.prevent="$event.target.blur()" v-b-modal.modal-update-direccion class="alter-btn">
                                        <span>Modificar</span>
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="col-12 main_content">
            <div class="main_icon">
                <svg width="36" height="37" focusable="false" fill="currentColor" viewBox="0 0 48 48" aria-hidden="true">
                    <defs></defs>
                    <g>
                        <path d="M11.7 32H6v2h4.3a4.5 4.5 0 0 1 1.4-2z"></path>
                        <path d="M29 16v16H18.8a5.6 5.6 0 1 0 1 2h10a5.5 5.5 0 1 0 10.5 0H42v-9c0-9-13-9-13-9zM14.5 39a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5zM35 39a3.5 3.5 0 1 1 3.5-3.5A3.5 3.5 0 0 1 35 39zm5-7h-.7a5.5 5.5 0 0 0-8.3-.3V18.1c3.2.4 9 1.8 9 6.9z"></path>
                        <path d="M27 29V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1zm-2-1H8V11h17z"></path>
                    </g>
                </svg>
            </div>
            <span class="text_alter">
                Todavía no has guardado ninguna dirección. Añade una para tu próximo pedido.
            </span>
            <div class="bp-form-group">
                <b-button v-b-modal.modal-new-direccion class="alter-btn" @focus.prevent="$event.target.blur()">
                    <span>Añadir nueva dirección</span>
                    <svg height="1em" width="1em" focusable="false"
                         fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M3 11.3H18L15 8l1-1 5.1 5-5 5-1-1 3.1-3.3H3v-1.4z"></path>
                    </svg>
                </b-button>
            </div>
        </div>

        <!-- COMPONENTE CREAR DIRECCIÓN -->
        <address-create></address-create>

        <b-modal id="modal-update-direccion" ref="modal_edit" title="Actualizar dirección" size="md" hide-footer>
            <form ref="form" @submit="submitUpdateDireccion">

<!--                <div class="bp-form-group">-->
<!--                    <div class="content-group">-->
<!--                        <div>-->
<!--                            <label for="nombre_direccion-input" class="form-label">Direccion nombre</label>-->
<!--                            <div class="content-input">-->
<!--                                <input id="nombre_direccion-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nombre_direccion }" v-model="form_edit.nombre_direccion" required>-->
<!--                                <div v-for="error in errors.nombre_direccion" class="invalid-feedback">-->
<!--                                    {{ error }}-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="nombre-input" class="form-label">Nombre</label>
                            <div class="content-input">
                                <input id="nombre-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nombre }" v-model="form_edit.nombre" required>
                                <div v-for="error in errors.nombre" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="apellidos-input" class="form-label">Apellidos</label>
                            <div class="content-input">
                                <input id="apellidos-input" type="text" :class="'form-element '+{ 'is-invalid': errors.apellidos }" v-model="form_edit.apellidos" required>
                                <div v-for="error in errors.apellidos" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="nombre_empresa-input" class="form-label">Empresa <span style="color: red">(Rellenar si necesitas factura a nombre de empresa)</span></label>
                            <div class="content-input">
                                <input id="nombre_empresa-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nombre_empresa }" v-model="form_edit.nombre_empresa">
                                <div v-for="error in errors.nombre_empresa" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="nif-input" class="form-label">DNI/CIF</label>
                            <div class="content-input">
                                <input id="nif-input" type="text" :class="'form-element '+{ 'is-invalid': errors.nif }" v-model="form_edit.nif" required>
                                <div v-for="error in errors.nif" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="direccion-input" class="form-label">Dirección</label>
                            <div class="content-input">
                                <input id="direccion-input" type="text" :class="'form-element '+{ 'is-invalid': errors.direccion }" v-model="form_edit.direccion" required>
                                <div v-for="error in errors.direccion" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="observaciones-input" class="form-label">Más información (opcional)</label>
                            <div class="content-input">
                                <input id="observaciones-input" type="text" :class="'form-element '+{ 'is-invalid': errors.observaciones }" v-model="form_edit.observaciones">
                                <div v-for="error in errors.observaciones" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="movil" class="form-label">Teléfono</label>
                            <div class="content-input">
                                <input id="movil" type="text" :class="'form-element '+{ 'is-invalid': errors.movil }" name="movil" placeholder="Movil" v-model="form_edit.movil" required>
                                <div v-for="error in errors.movil" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="cod_postal-input" class="form-label">Código postal</label>
                            <div class="content-input">
                                <input id="cod_postal-input" type="text" :class="'form-element '+{ 'is-invalid': errors.cod_postal }" v-model="form_edit.cod_postal" required>
                                <div v-for="error in errors.cod_postal" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="poblacion_nombre-input" class="form-label">Población</label>
                            <div class="content-input">
                                <input id="poblacion_nombre-input" type="text" :class="'form-element '+{ 'is-invalid': errors.poblacion_nombre }" v-model="form_edit.poblacion_nombre" required>
                                <div v-for="error in errors.poblacion_nombre" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="pais-input" class="form-label">Pais</label>
                            <div class="content-input">
                                <b-form-select id="pais-input" :class="'form-element '+{ 'is-invalid': errors.pais_id }" @change="loadProvincias($event)" v-model="form_edit.pais_id">
                                    <option value="" selected>-- Selecciona pais --</option>
                                    <option v-for="pais in paises" :value="pais.id">{{ pais.nombre }}</option>
                                </b-form-select>
                                <div v-for="error in errors.pais_id" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div>
                            <label for="provincia-input" class="form-label">Provincia</label>
                            <div class="content-input">
                                <b-form-select id="provincia-input" :class="'form-element '+{ 'is-invalid': errors.provincia_id }" v-model="form_edit.provincia_id">
                                    <option value="" selected>-- Selecciona provincia --</option>
                                    <option v-for="provincia in provincias" :value="provincia.id">{{ provincia.nombre }}</option>
                                </b-form-select>
                                <div v-for="error in errors.provincia_id" class="invalid-feedback">
                                    {{ error }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div class="type-client-selection visual_ceck">
                            <div class="pb-3 recargoVisual">
                                <input type="checkbox" tabindex="0" id="requiere_re" v-model="form_edit.requiere_re" :class="'form-element '+{ 'is-invalid': errors.requiere_re }" >
                                <label class="text" for="requiere_re">
                                    Necesito 'Recargo de equivalencia' en la facturación del pedido.
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div class="type-client-selection newsletter">
                            <div>
                                <input type="checkbox" tabindex="0" id="pred_envio" v-model="form_edit.pred_envio" :class="'form-element '+{ 'is-invalid': errors.pred_envio }" >
                                <label class="text" for="pred_envio">
                                    Seleccionar direccion como direccion de envio predeterminada para futuros pedidos
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bp-form-group">
                    <div class="content-group">
                        <div class="type-client-selection newsletter">
                            <div>
                                <input type="checkbox" tabindex="0" id="pred_facturacion" v-model="form_edit.pred_facturacion" :class="'form-element '+{ 'is-invalid': errors.pred_facturacion }" >
                                <label class="text" for="pred_facturacion">
                                    Seleccionar direccion como direccion de facturacion predeterminada para futuros pedidos
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="errors" class="invalid-feedback text-center">
                    Hay errores en la dirección. Revisa los datos y vuelve a intentarlo.
                </div>

                <div class="bp-form-group">
                    <button class="alter-btn-green" type="submit" data-testid="login_button">
                        <span>Guardar dirección</span>
                    </button>
                </div>

            </form>
        </b-modal>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                direcciones: [],
                paises: "",
                provincias: "",
                errors: "",
                form_edit: "",
            }
        },
        mounted() {
            this.loadAddressClient();
            this.loadPaises();

            this.$on('loadAddressClient', function(){
                this.loadAddressClient()
            });
        },
        methods: {
            loadAddressClient: function () {
                axios.get('/account/direccion/get-address').then(response => {
                    this.direcciones = response.data.addresses;
                }).catch(e => {
                    console.log(e);
                });
            },
            editAddress: function (index) {
                this.form_edit = this.direcciones[index];
                this.loadProvincias(this.direcciones[index].pais_id);
                this.$refs.modal_edit.show();
            },
            loadPaises: function () {
                axios.get('/account/get-paises').then(response => {
                    this.paises = response.data.paises;
                }).catch(e => {
                    console.log(e);
                });
            },
            loadProvincias: function (pais_id) {
                axios.post('/account/get-provincias',{
                    pais_id: pais_id
                }).then(response => {
                    this.provincias = response.data.provincias;
                }).catch(e => {
                    console.log(e);
                });
            },
            submitUpdateDireccion(evt) {
                this.errors = "";
                evt.preventDefault();
                axios.put('/account/direccion/update',this.form_edit).then(response => {
                    this.loadAddressClient();
                    this.$refs.modal_edit.hide();
                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    Vue.toasted.show('Ha habido un error!', {
                        type: "error",
                        duration: 3000
                    });
                    if (e.response.status === 422) {
                        console.log(e.response.status);
                        this.errors = e.response.data.errors;
                    }
                });
            },
            removeAddress: function (address_id) {

                if(confirm("¿Seguro que quieres eliminar esta dirección?")){
                    axios.post('/account/direccion/delete', {
                        address_id: address_id,
                    }).then(response => {
                        this.loadAddressClient();
                        Vue.toasted.show(response.data.info, {
                            type: "success",
                            duration: 3000
                        });
                    }).catch(e => {
                        Vue.toasted.show(e.response.data.info?e.response.data.info:'Ha habido un error!', {
                            type: "error",
                            duration: 3000
                        });
                        console.log(e);
                    });
                }

            }
        }
    }
</script>
